"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Button` instead */
export const Button = createSVGIcon(
  <>
    <path
      d="m20 17.259-3.693-3.704 1.847-1.852a.926.926 0 0 0-.462-1.556l-8.548-2.12a.92.92 0 0 0-1.11.65.93.93 0 0 0-.007.47l2.114 8.575a.927.927 0 0 0 1.133.669.9.9 0 0 0 .418-.243l1.846-1.852L17.231 20z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12H3.85C3 12 2 11.385 2 10V6c0-1.5 1-2 2.5-2H20c1 0 2 .5 2 2v4c0 1.5-1 2-2 2h-2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Button",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Add button",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
